import axios from 'axios';
import {
    actions as modalActions,
} from '../../modals';
import {
    requestLogout,
} from '../loginPage/login.actions';
import {
    actions as betActions,
} from '../bet';
import {
    getCurrentTime,
} from '../utils/currentDate';
import {
    resetEmptyBetslip,
} from '../../drawer/drawer.actions';
import {
    actions as freeBetActions,
} from '../freeBets';
import ApiClient from '../utils/apiClient';
import {
    isUnknownError,
    isGenericError,
    getErrorsToFire,
} from '../utils/apiErrors';
import updateAuthToken from '../utils/updateAuthToken';

const MILISECONDS_IN_DAY = 86400000;

export const actionTypes = {
    SET_SELECTED_BOOKMAKER: 'SET_SELECTED_BOOKMAKER',
    SET_BOOKMAKERS_ORDER: 'SET_BOOKMAKERS_ORDER',
    ADD_SELECTED_BET: 'ADD_SELECTED_BET',
    CLEAR_SELECTED_BETS: 'CLEAR_SELECTED_BETS',
    DELETE_BET: 'DELETE_BET',
    SET_STAKE_FOR_SELECTED_BET: 'SET_STAKE_FOR_SELECTED_BET',
    SET_ISEACHWAY_FOR_SELECTED_BET: 'SET_ISEACHWAY_FOR_SELECTED_BET',
    SET_PRICE_TYPE_FOR_SELECTED_BET: 'SET_PRICE_TYPE_FOR_SELECTED_BET',
    TOGGLE_BALANCE_VISIBILITY: 'TOGGLE_BALANCE_VISIBILITY',
    SAVE_USERNAME: 'SAVE_USERNAME',
    REMOVE_USERNAME: 'REMOVE_USERNAME',
    SET_IS_EDITING_STAKE: 'SET_IS_EDITING_STAKE',
    SET_MINIMUM_STAKE: 'SET_MINIMUM_STAKE',
    SET_MAXIMUM_STAKE: 'SET_MAXIMUM_STAKE',
    SET_LOCKED_STAKE: 'SET_LOCKED_STAKE',
    CLEAR_LOCKED_STAKE: 'CLEAR_LOCKED_STAKE',

    // Build Bets
    BUILD_BET_REQUEST: 'BUILD_BET_REQUEST',
    ASSOCIATE_SINGLES: 'ASSOCIATE_SINGLES',

    // Multiples
    BUILD_MULTIPLES_REQUEST: 'BUILD_MULTIPLES_REQUEST',
    SET_MULTIPLES: 'SET_MULTIPLES',
    CLEAR_MULTIPLES: 'CLEAR_MULTIPLES',
    SET_STAKE_FOR_MULTIPLE: 'SET_STAKE_FOR_MULTIPLE',
    SET_IS_EACHWAY_FOR_MULTIPLE: 'SET_IS_EACHWAY_FOR_MULTIPLE',
    SET_IS_EDITING_STAKE_FOR_MULTIPLE: 'SET_IS_EDITING_STAKE_FOR_MULTIPLE',
    TOGGLE_MULTIPLES_INCLUSION: 'TOGGLE_MULTIPLES_INCLUSION',
    SET_MULTIPLES_ERROR: 'SET_MULTIPLES_ERROR',
    CLEAR_MULTIPLES_ERROR: 'CLEAR_MULTIPLES_ERROR',
    CLEAR_ALL_MULTIPLES_ERRORS: 'CLEAR_ALL_MULTIPLES_ERRORS',
    SAVE_MULTIPLES_STAKES: 'SAVE_MULTIPLES_STAKES',
    SAVE_MULTIPLES_EACHWAY: 'SAVE_MULTIPLES_EACHWAY',
    RESTORE_MULTIPLES_STAKES: 'RESTORE_MULTIPLES_STAKES',
    RESTORE_MULTIPLES_EACHWAY: 'RESTORE_MULTIPLES_EACHWAY',
    CHANGE_SELECTION_ORDER: 'CHANGE_SELECTION_ORDER',

    // Errors
    SET_ERROR: 'SET_ERROR',
    SET_ERROR_ON_BUILD: 'SET_ERROR_ON_BUILD',
    CLEAR_ERROR: 'CLEAR_ERROR',
    CLEAR_ALL_ERRORS: 'CLEAR_ALL_ERRORS',
    SET_SUSPENDED_BET: 'SET_SUSPENDED_BET',
    SET_SUSPENDED_BET_ON_BUILD: 'SET_SUSPENDED_BET_ON_BUILD',
    CLEAR_SUSPENDED_BETS: 'CLEAR_SUSPENDED_BETS',
    SET_PRICE_CHANGED: 'SET_PRICE_CHANGED',
    SET_PRICE_CHANGED_ON_BUILD: 'SET_PRICE_CHANGED_ON_BUILD',
    UPDATE_ALL_BET_PRICES: 'UPDATE_ALL_BET_PRICES',
    UPDATE_BET_PRICE: 'UPDATE_BET_PRICE',
    SET_GENERIC_ERROR: 'SET_GENERIC_ERROR',
    SET_GENERIC_ERROR_ON_BUILD: 'SET_GENERIC_ERROR_ON_BUILD',
    CLEAR_GENERIC_ERROR: 'CLEAR_GENERIC_ERROR',
    UPDATE_ALL_STARTING_PRICES_AVAILABILITY: 'UPDATE_ALL_STARTING_PRICES_AVAILABILITY',

    // Un-used Bets (Re-use Selection feature)
    SET_UNUSED_BETS: 'SET_UNUSED_BETS',
    CLEAR_UNUSED_BETS: 'CLEAR_UNUSED_BETS',

    // Free bets
    SET_FREE_BET_MINIMUM_STAKE: 'SET_FREE_BET_MINIMUM_STAKE',
    SET_FREE_BET_MAXIMUM_STAKE: 'SET_FREE_BET_MAXIMUM_STAKE',
};

// Singles...
// ------------------------------------------------
export const buildBetRequest = isBuildingBet => ({
    type: actionTypes.BUILD_BET_REQUEST,
    isBuildingBet,
});

export const addSelectedBet = betInfo => ({
    type: actionTypes.ADD_SELECTED_BET,
    betInfo,
})

export const clearSelectedBets = () => ({
    type: actionTypes.CLEAR_SELECTED_BETS,
});

export const deleteBet = outcomersId => ({
    type: actionTypes.DELETE_BET,
    outcomersId,
})

export const setStakeForSelectedBet = (outcomersId, stake) => ({
    type: actionTypes.SET_STAKE_FOR_SELECTED_BET,
    outcomersId,
    stake,
});

export const setIsEachWayForSelectedBet = (outcomersId, isEachWay) => ({
    type: actionTypes.SET_ISEACHWAY_FOR_SELECTED_BET,
    outcomersId,
    isEachWay,
});

export const setIsEditingStake = (outcomersId, isEditingStake) => ({
    type: actionTypes.SET_IS_EDITING_STAKE,
    outcomersId,
    isEditingStake,
});

export const setPriceTypeForSelectedBet = (outcomersId, priceType) => ({
    type: actionTypes.SET_PRICE_TYPE_FOR_SELECTED_BET,
    outcomersId,
    priceType,
});

export const setSuspendedBet = (outcomersId, isSuspended) => ({
    type: actionTypes.SET_SUSPENDED_BET,
    outcomersId,
    isSuspended,
});

export const setSuspendedBetOnBuild = (outcomersId, isSuspended) => ({
    type: actionTypes.SET_SUSPENDED_BET_ON_BUILD,
    outcomersId,
    isSuspended,
});

export const clearSuspendedBets = () => ({
    type: actionTypes.CLEAR_SUSPENDED_BETS,
});

export const setAssociatedPriceChange = (outcomersId, fractionalPrice, decimalPrice) => ({
    type: actionTypes.SET_PRICE_CHANGED,
    outcomersId,
    fractionalPrice,
    decimalPrice,
});

export const setAssociatedPriceChangeOnBuild = (outcomersId, fractionalPrice, decimalPrice) => ({
    type: actionTypes.SET_PRICE_CHANGED_ON_BUILD,
    outcomersId,
    fractionalPrice,
    decimalPrice,
});

export const updateBetPrice = (outcomersId, fractionalPrice, decimalPrice) => ({
    type: actionTypes.UPDATE_BET_PRICE,
    outcomersId,
    fractionalPrice,
    decimalPrice,
});

export const updateAllBetPrices = () => ({
    type: actionTypes.UPDATE_ALL_BET_PRICES,
});

export const updateAllStartingPricesAvailability = () => ({
    type: actionTypes.UPDATE_ALL_STARTING_PRICES_AVAILABILITY,
});

export const setUnusedBets = unusedBets => ({
    type: actionTypes.SET_UNUSED_BETS,
    unusedBets,
})

export const clearUnusedBets = () => ({
    type: actionTypes.CLEAR_UNUSED_BETS,
})

const setAssociatedBets = singles => ({
    type: actionTypes.ASSOCIATE_SINGLES,
    singles,
})

export const setMinimumStake = (outcomersId, minimumStake) => ({
    type: actionTypes.SET_MINIMUM_STAKE,
    outcomersId,
    minimumStake,
})

export const setMaximumStake = (outcomersId, maximumStake) => ({
    type: actionTypes.SET_MAXIMUM_STAKE,
    outcomersId,
    maximumStake,
})

export const setFreeBetMinimumStake = (outcomersId, minimumStake) => ({
    type: actionTypes.SET_FREE_BET_MINIMUM_STAKE,
    outcomersId,
    minimumStake,
})

export const setFreeBetMaximumStake = (outcomersId, maximumStake) => ({
    type: actionTypes.SET_FREE_BET_MAXIMUM_STAKE,
    outcomersId,
    maximumStake,
})

export const setLockedStake = (outcomersId, stake) => ({
    type: actionTypes.SET_LOCKED_STAKE,
    outcomersId,
    stake,
})

export const clearLockedStake = outcomersId => ({
    type: actionTypes.CLEAR_LOCKED_STAKE,
    outcomersId,
})

// Multiples...
// ------------------------------------------------

export const buildMultiplesRequest = isBuildingMultiples => ({
    type: actionTypes.BUILD_MULTIPLES_REQUEST,
    isBuildingMultiples,
})

export const toggleMultiplesInclusion = (outcomersId, include) => ({
    type: actionTypes.TOGGLE_MULTIPLES_INCLUSION,
    outcomersId,
    include,
})

export const clearMultiples = () => ({
    type: actionTypes.CLEAR_MULTIPLES,
})

export const setStakeForMultiple = (optionId, stake) => ({
    type: actionTypes.SET_STAKE_FOR_MULTIPLE,
    optionId,
    stake,
});

export const setIsEachWayForMultiple = (optionId, isEachWay) => ({
    type: actionTypes.SET_IS_EACHWAY_FOR_MULTIPLE,
    optionId,
    isEachWay,
});

export const setIsEditingStakeForMultiple = (optionId, isEditingStake) => ({
    type: actionTypes.SET_IS_EDITING_STAKE_FOR_MULTIPLE,
    optionId,
    isEditingStake,
});

export const removeAllBets = () => (dispatch) => {
    dispatch(clearSelectedBets())
    dispatch(clearMultiples())
    dispatch(betActions.setBetObstruction(betActions.betObstructions.NONE));
}

const setMultiples = multiples => ({
    type: actionTypes.SET_MULTIPLES,
    multiples,
})

export const saveMultiplesStakes = () => ({
    type: actionTypes.SAVE_MULTIPLES_STAKES,
})

export const saveMultiplesEachWay = () => ({
    type: actionTypes.SAVE_MULTIPLES_EACHWAY,
})

export const restoreMultiplesStakes = () => ({
    type: actionTypes.RESTORE_MULTIPLES_STAKES,
})

export const restoreMultiplesEachWay = () => ({
    type: actionTypes.RESTORE_MULTIPLES_EACHWAY,
})

const reconcileBetOptions = options => (dispatch) => {
    const singles = options.reduce((singlesOptions, option) => {
        if (option.attributes.betType === 'single') {
            singlesOptions.push({
                optionId: option.id,
                outcomersId: option.attributes.betSelections[0].selectionId,
                eventId: option.attributes.betSelections[0].eventId,
                marketId: option.attributes.betSelections[0].marketId,
                minStake: option.attributes.minStake,
                maxStake: option.attributes.maxStake,
                numberLines: option.attributes.numberLines,
            })
        }
        return singlesOptions
    }, [])

    if (singles.length) {
        dispatch(setAssociatedBets(singles))
    }

    dispatch(buildBetRequest(false))
}

const reconcileMultiplesOptions = options => (dispatch) => {
    const multiples = options.reduce((multiplesOptions, option) => {
        if (option.attributes.betType !== 'single') {
            multiplesOptions.push({
                optionId: option.id,
                betType: option.attributes.betType,
                minStake: option.attributes.minStake,
                maxStake: option.attributes.maxStake,
                numberLines: option.attributes.numberLines,
                betSelections: option.attributes.betSelections,
            })
        }
        return multiplesOptions
    }, [])

    if (multiples.length) {
        dispatch(setMultiples(multiples))
        dispatch(restoreMultiplesStakes())
        dispatch(restoreMultiplesEachWay())
    }

    dispatch(buildMultiplesRequest(false));
}

export const buildBets = (
    apiName,
    selectedBets,
    feed,
    isExternalLogout,
    currencySign,
) => (dispatch) => {
    const onUnauthorized = requestLogout(apiName, feed, isExternalLogout)

    return ApiClient.buildBets(
            apiName,
            selectedBets,
            dispatch,
            onUnauthorized,
        )
        .then((response) => {
            const options = response.data.data
            updateAuthToken(response.headers);
            dispatch(reconcileBetOptions(options))
            const freeBets = response.data.meta.freeBets
            dispatch(freeBetActions.setFreeBets(freeBets))
        })
        .catch((error) => {
            // Don't proceed if it was a cancelled request
            if (axios.isCancel(error)) {
                return Promise.resolve()
            }

            dispatch(buildBetRequest(false))

            if (isUnknownError(error)) {
                return Promise.resolve()
            }

            const body = error.response.data

            if (isGenericError(body)) {
                return Promise.resolve()
            }

            // Logically determine which errors to fire & fire them
            const errorsToFire = getErrorsToFire(body.errors)
            errorsToFire.map(
                errorToFire => betActions.fireError(dispatch, 'BUILD', errorToFire, currencySign),
            )

            // Update CTA obstruction according to errors that were fired
            const errorCodes = errorsToFire.map(errorToFire => errorToFire.code)
            dispatch(betActions.updateObstructions(errorCodes))

            return Promise.resolve()
        })
}

export const buildMultiples = (
    apiName,
    selectedBets,
    feed,
    isExternalLogout,
    currencySign,
) => (dispatch) => {
    const onUnauthorized = requestLogout(apiName, feed, isExternalLogout)

    return ApiClient.buildMultiples(apiName, selectedBets, dispatch, onUnauthorized)
        .then((response) => {
            updateAuthToken(response.headers);
            const options = response.data.data
            dispatch(reconcileMultiplesOptions(options))
        })
        .catch((error) => {
            // Don't proceed if it was a cancelled request
            if (axios.isCancel(error)) {
                return Promise.resolve()
            }

            dispatch(buildMultiplesRequest(false))

            const body = error.response.data

            if (isGenericError(body)) {
                return Promise.resolve()
            }

            // Logically determine which errors to fire & fire them
            const errorsToFire = getErrorsToFire(body.errors)
            errorsToFire.map(
                errorToFire => betActions.fireError(dispatch, 'BUILD', errorToFire, currencySign),
            )

            // Update CTA obstruction according to errors that were fired
            const errorCodes = errorsToFire.map(errorToFire => errorToFire.code)
            dispatch(betActions.updateObstructions(errorCodes))

            return Promise.resolve()
        })
}

export const cancelBuildMultiples = () => (dispatch) => {
    ApiClient.cancelBuildMultiples()
    dispatch(buildMultiplesRequest(false))
}

export const changeSelectionOrder = (optionId, selectionId, index) => ({
    type: actionTypes.CHANGE_SELECTION_ORDER,
    optionId,
    selectionId,
    index,
});

// Bookmaker...
// ------------------------------------------------
export const setSelectedBookmaker = feed => ({
    type: actionTypes.SET_SELECTED_BOOKMAKER,
    feed,
});

export const toggleBalanceVisibility = feed => ({
    type: actionTypes.TOGGLE_BALANCE_VISIBILITY,
    feed,
});

export const saveUsername = (feed, username) => ({
    type: actionTypes.SAVE_USERNAME,
    feed,
    username,
});

export const removeUsername = feed => ({
    type: actionTypes.REMOVE_USERNAME,
    feed,
});

export const setBookmakersOrder = (sortingFunction, bookmakersList) => ({
    type: actionTypes.SET_BOOKMAKERS_ORDER,
    bookmakersOrder: bookmakersList
        .map(({
            feed,
        }) => feed)
        .sort(sortingFunction),
    orderExpiration: getCurrentTime() + MILISECONDS_IN_DAY,
});

export const setError = (outcomersId, errorId, message) => ({
    type: actionTypes.SET_ERROR,
    outcomersId,
    error: {
        errorId,
        message,
    },
});

export const setErrorOnBuild = (outcomersId, errorId, message) => ({
    type: actionTypes.SET_ERROR_ON_BUILD,
    outcomersId,
    error: {
        errorId,
        message,
    },
});

export const clearError = outcomersId => ({
    type: actionTypes.CLEAR_ERROR,
    outcomersId,
});

export const clearAllErrors = () => ({
    type: actionTypes.CLEAR_ALL_ERRORS,
})

export const setGenericError = (errorId, message) => ({
    type: actionTypes.SET_GENERIC_ERROR,
    error: {
        errorId,
        message,
    },
})

export const setGenericErrorOnBuild = (errorId, message) => ({
    type: actionTypes.SET_GENERIC_ERROR_ON_BUILD,
    error: {
        errorId,
        message,
    },
})

export const clearGenericError = () => ({
    type: actionTypes.CLEAR_GENERIC_ERROR,
})

export const setMultiplesError = (optionId, errorId, message) => ({
    type: actionTypes.SET_MULTIPLES_ERROR,
    optionId,
    error: {
        errorId,
        message,
    },
})

export const clearMultiplesError = optionId => ({
    type: actionTypes.CLEAR_MULTIPLES_ERROR,
    optionId,
})

export const clearAllMultiplesErrors = () => ({
    type: actionTypes.CLEAR_ALL_MULTIPLES_ERRORS,
})

export const selectBookmaker = (
        feed,
        sortingFunction,
        bookmakersList,
        shouldShowModal = true,
    ) =>
    (dispatch) => {
        if (shouldShowModal) {
            dispatch(modalActions.showSelectionInfoModal());
        }
        dispatch(setBookmakersOrder(sortingFunction, bookmakersList));
        dispatch(setSelectedBookmaker(feed));
        dispatch(clearSelectedBets());
        dispatch(clearMultiples());
        dispatch(resetEmptyBetslip());
        dispatch(betActions.setBetObstruction(betActions.betObstructions.NONE));
        dispatch(betActions.clearPlacedBetDetails());
    };



// WEBPACK FOOTER //
// /src/js/common/bookmakersInfo/bookmakersInfo.actions.js